import { useHostClientContext } from '../../HostClientProvider/hooks/useHostClientContext';

export const useToggleSessionLocked = () => {
  const { client } = useHostClientContext();

  const toggleIsSessionLocked = () => {
    client.setIsSessionBlocked(!client.game.isSessionBlocked);
  };

  return {
    isSessionLocked: client.game.isSessionBlocked,
    toggleIsSessionLocked,
  };
};
